export default function sumArray(arr: Array<number>): number {
  return arr.reduce((acc, currVal) => acc + currVal, 0);
}
